import { useQuery } from '@tanstack/react-query';

import { useProfileId } from '@/features/org/hooks/use-profile-id';
import { getUserProfile } from '@/features/profile/api/get-user-profile';

export const getUserProfileQueryKey = (profileId?: string) => [
  'userProfile',
  profileId,
];

export function useUserProfile() {
  const { data: profileId } = useProfileId();

  return useQuery({
    queryKey: getUserProfileQueryKey(profileId),
    queryFn: () => getUserProfile(profileId ?? ''),
    enabled: !!profileId,
  });
}
